import { render } from "./LabelsSettingsPage.vue?vue&type=template&id=42e9f856&scoped=true"
import script from "./LabelsSettingsPage.vue?vue&type=script&lang=js"
export * from "./LabelsSettingsPage.vue?vue&type=script&lang=js"

import "./LabelsSettingsPage.vue?vue&type=style&index=0&id=42e9f856&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42e9f856"]])

export default __exports__